var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconButton',{attrs:{"icon":"mdi-location-exit","tooltip-text":_vm.$t('LogOut'),"button-class":"ml-3"},on:{"click":_vm.handleLogout}})
}
var staticRenderFns = []

export { render, staticRenderFns }